import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import StrianoLogo from "../components/StrianoLogo";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090D16] bg-grid flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center mb-3">
            <StrianoLogo variant="full" size={140}/>
          </div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-mono-num">Executive Fleet Management</div>
        </div>

        <form onSubmit={submit} className="rounded-2xl border border-slate-800 bg-slate-950/80 backdrop-blur-md p-8 space-y-5 shadow-2xl">
          <div>
            <Label className="text-slate-400 text-xs uppercase tracking-widest">Email</Label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1.5 bg-slate-900 border-slate-800 text-white" />
          </div>
          <div>
            <Label className="text-slate-400 text-xs uppercase tracking-widest">Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-1.5 bg-luxe-sub border-gold/25 text-white focus-visible:ring-gold/50" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold uppercase tracking-wide">
            {loading ? "Accesso..." : "Accedi"}
          </Button>
          <div className="text-center pt-1">
            <Link data-testid="forgot-password-link" to="/forgot-password" className="text-xs text-amber-400 hover:text-amber-300 font-semibold uppercase tracking-widest">
              Password dimenticata?
            </Link>
          </div>
          <div className="text-xs text-slate-500 text-center pt-1">
            Utente admin di sistema seed nel database
          </div>
        </form>
      </div>
    </div>
  );
}
